export default "__VITE_ASSET__663fda15__"